// shared course tab styles used across admin and course pages
import { palette } from '@mui/system';

export const tabPanelBoxStyles = {
  flex: '1 1 250px',
  minWidth: '250px',
  maxWidth: '300px',
  flex: { xs: '1 1 100%', sm: '0 0 280px' },
  width: { xs: '100%', sm: 280 },
  height: { xs: 350, sm: 480 },
  minHeight: { xs: 350, sm: 480 },
  display: 'flex',
  flexDirection: 'column',
  overflowX: 'hidden',
  border: '1px solid',
  boxShadow: 0,
  borderColor: 'divider',
  bgcolor: 'background.main',
};

export const baseItemSx = {
  textTransform: 'none',
  minHeight: 'auto',
  px: 1.5,
  py: 0.8,
  fontSize: '0.90rem',
  '&.Mui-selected': {
    backgroundColor: 'info.light',
    fontWeight: 600,
  },
};

export const deptItemSx = {
  ...baseItemSx,
  fontSize: '1rem',
  justifyContent: 'center',
  textAlign: 'center',
};

export const courseItemSx = {
  ...baseItemSx,
  justifyContent: 'center',
  textAlign: 'center',
};

export const profItemSx = {
  ...deptItemSx,
};

